<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <admin-shop @shop-change="handleShopChange"></admin-shop>
      </el-col>
      <el-col :span="20">
        <el-card class="">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('printerMachineLog.queryCondition') }}</span>
          </div>
          <el-form :inline="true" :model="printerMachineLogInfo.conditions" class="flex justify-start">
            <el-form-item>
              <el-input :placeholder="$t('printerMachineLog.selectMachineCode')"
                v-model="printerMachineLogInfo.conditions.machineCode" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="_queryPrinterLogMethod">
                {{ $t('printerMachineLog.query') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('printerMachineLog.printLog') }}</span>
          </div>
          <el-table :data="printerMachineLogInfo.logs" border style="width: 100%" size="small">
            <el-table-column prop="orderId" :label="$t('printerMachineLog.id')" align="center"></el-table-column>
            <el-table-column prop="machineCode" :label="$t('printerMachineLog.machineCode')"
              align="center"></el-table-column>
            <el-table-column prop="shopName" :label="$t('printerMachineLog.shop')" align="center"></el-table-column>
            <el-table-column prop="reqParam" :label="$t('printerMachineLog.requestMessage')" align="center" width="200">
              <template slot-scope="scope">
                <div class="textAuto">{{ scope.row.reqParam }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="resParam" :label="$t('printerMachineLog.responseMessage')" align="center"
              width="200">
              <template slot-scope="scope">
                <div class="textAuto">{{ scope.row.resParam }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('printerMachineLog.requestTime')"
              align="center"></el-table-column>
          </el-table>

          <el-pagination @current-change="handleCurrentChange" :current-page="printerMachineLogInfo.conditions.page"
            :page-size="printerMachineLogInfo.conditions.row" layout="total, prev, pager, next"
            :total="printerMachineLogInfo.total" style="margin-top: 20px;"></el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listShopPrinterLog } from '@/api/shop/printerMachineLogApi'
import AdminShop from '@/components/shop/adminShop.vue'

export default {
  name: 'PrinterMachineLog',
  components: {
    AdminShop
  },
  data() {
    return {
      printerMachineLogInfo: {
        logs: [],
        total: 0,
        conditions: {
          machineCode: '',
          shopId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listPrinterMachineLogs()
  },
  methods: {
    handleShopChange(shop) {
      this.printerMachineLogInfo.conditions.shopId = shop.shopId
      this._listPrinterMachineLogs()
    },
    handleCurrentChange(val) {
      this.printerMachineLogInfo.conditions.page = val
      this._listPrinterMachineLogs()
    },
    async _listPrinterMachineLogs() {
      try {
        const res = await listShopPrinterLog(this.printerMachineLogInfo.conditions)
        this.printerMachineLogInfo.logs = res.data
        this.printerMachineLogInfo.total = res.total
      } catch (error) {
        console.error('获取打印日志失败:', error)
      }
    },
    _queryPrinterLogMethod() {
      this.printerMachineLogInfo.conditions.page = 1
      this._listPrinterMachineLogs()
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.textAuto {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>